import GalleryContainer from 'components/Gallery/GalleryContainer'
import GalleryPresentation from 'components/Gallery/GalleryPresentation'

export default {
  Container: GalleryContainer,
  Presentation: GalleryPresentation,
}
